import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ReportSummaryTransactionResellerPageRoutingModule } from './report-summary-transaction-reseller-routing.module';

import { ReportSummaryTransactionResellerPage } from './report-summary-transaction-reseller.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReportSummaryTransactionResellerPageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [ReportSummaryTransactionResellerPage]
})
export class ReportSummaryTransactionResellerPageModule {}
